import { Component, OnInit } from '@angular/core';
import { Bank } from '../bank';
import { Observable } from 'rxjs/Observable';
import { SettingsService } from '../../../shared/services/settings.service';
import { BankService } from '../../../shared/services/bank.service';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { Location } from '@angular/common';
import { TdDialogService } from '@covalent/core';

@Component({
  selector: 'app-account-transfer',
  templateUrl: './account-transfer.component.html',
  styleUrls: ['./account-transfer.component.scss'],
  providers: [BankService]
})
export class AccountTransferComponent implements OnInit {
  allAccounts$: Observable<Bank[]>;

  description: string;
  date: string = new Date().toISOString().substr(0, 10);
  from_account_id: string;
  from_amount: number;
  currency_exchange_rate: number;
  to_account_id: string;
  to_amount: number;
  _creating: boolean = false;

  bank_id_to_currency: { bank_id: string, bank_name: string, currency: string }[] = [];

  constructor(public _settingsService: SettingsService,
    private _bankService: BankService,
    private route: ActivatedRoute,
    private _dialog: TdDialogService,
    private _location: Location) { }

  ngOnInit() {
    this.allAccounts$ = this._bankService.getBanks().do(
      (banks: Bank[]) => {
        banks.forEach(
          (b: Bank) => {
            this.bank_id_to_currency.push({ bank_id: b.id + '', bank_name: b.name, currency: b.currency });
          }
        );
      }
    );

    this.route.paramMap.subscribe(
      (params: ParamMap) => {
        this.from_account_id = params.get('id');

        console.log(this.from_account_id);
      }
    )
  }

  createTransfer() {

    // if not the same year or not the same month, ask for confirmation
    if (this.date.substr(0, 4) !== new Date().toISOString().substr(0, 4)
      || this.date.substr(5, 2) !== new Date().toISOString().substr(5, 2)) {

      this._dialog.openConfirm(
        {
          title: 'Confirm Action',
          message: 'The date you have selected is for a different month, are you sure the date is correct?'
        }
      ).afterClosed().subscribe(
        result => {
          if (result) {

            this.doCreate();
          }
        }
      );
    } else {

      this.doCreate();
    }
  }

  doCreate() {
    this._creating = true;

    let _description: string = (this.description || '') + 
    ' (Transfer From Account ' + this.from_account_id + ' To ' + this.to_account_id +
    ', exchange rate: ' + this.currency_exchange_rate + ')';
    this._bankService.transfer(_description, this.date, this.from_amount, this.from_account_id, this.to_amount, this.to_account_id).subscribe(
      response => {
        if (response && response['status'] == 'SUCCESS') {
          this._dialog.openAlert({ title: 'Success', message: 'Transfer successfully saved' }).afterClosed().subscribe(
            () => {
              this.goBack();
              this._creating = false;
            }
          );
        } else {
          this._dialog.openAlert({ title: 'Error', message: 'Error when creating Transfer' });
          this._creating = false;
        }
      },
      error => {
        this._dialog.openAlert({ title: 'Error', message: 'Error when creating Transfer' });
        this._creating = false;
      }
    );
  }

  getCurrency(bank_id): string {
    return (this.bank_id_to_currency.find(b => { return b.bank_id == bank_id }) || new Bank())['currency'];
  }

  getFromAccountName(): string {
    return (this.bank_id_to_currency.find(b => { return b.bank_id == this.from_account_id }) || new Bank())['bank_name'];
  }

  goBack() {
    this._location.back();
  }

}



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/app/agatextscreens/accounting/account-transfer/account-transfer.component.ts